export interface IContentProps {
  isCateringOrder?: boolean;
  upsellEnabled?: boolean;
  mobileCartUpsellLocation?: string;
}

export enum MobileAreaOptions {
  DETAILS = 'details',
  CART = 'cart',
  PAYMENT = 'payment',
  UPSELL = 'upsell',
}

export enum WebAreaOptions {
  DETAILS = 'details  cart',
  PAYMENT = 'payment  cart',
  UPSELL = 'upsell  cart',
  UNNAMED = '.  payment',
}
